import {Inject, Injectable, LOCALE_ID} from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DateTimeService {

	constructor(@Inject(LOCALE_ID) private lang: string) {
	}

	/**
	 * @param input - unix timestamp in ms
	 * @return formatted date/time in the format.
	 * MM/DD/YYYY hh:mm AM/PM - for en-US locale.
	 * DD/MM/YYYY hh:mm AM/PM - for non en-US locale.
	 */
	public getDateTimeFromUnixTimestamp(input: number): string {
		return this.getDateTimeFromJSDate(new Date(input));
	}

	/**
	 * @return formatted date/time in the format.
	 * MM/DD/YYYY hh:mm AM/PM - for en-US locale.
	 * DD/MM/YYYY hh:mm AM/PM - for non en-US locale.
	 */
	public getDateTimeFromJSDate(date: Date) {
		const month = this.padValue(date.getMonth() + 1);
		const day = this.padValue(date.getDate());
		const year = date.getFullYear();

		const formatDate = this.isEnUSLocale() ? this.formatToEnUSDateFormat : this.formatToDefaultFormat;
		const datePart = formatDate(day, month, year);
		const timePart = this.formatAMPM(date);
		return datePart + ' ' + timePart;
	}

	private formatToEnUSDateFormat(day, month, year) {
		return month + '/' + day + '/' + year;
	}

	private formatToDefaultFormat(day, month, year) {
		return day + '/' + month + '/' + year;
	}

	private isEnUSLocale() {
		return this.lang === 'en-US';
	}

	private formatAMPM(date) {
		let hours = date.getHours();
		let minutes = date.getMinutes();
		const ampm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		return hours + ':' + minutes + ' ' + ampm;
	}

	private padValue(value) {
		return (value < 10) ? '0' + value : value;
	}
}
